import { cn } from 'lib/utils';
import { Pagination, PaginationContent, PaginationItem, PaginationPrevious, PaginationNext } from 'components/ui/pagination';

interface Props {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const TablePagination = ({ page, totalPages, onPageChange }: Props) => {
  return (
    <Pagination className=''>
      <PaginationContent className='w-full justify-between items-center my-2'>
        <PaginationItem>
          <PaginationPrevious
            onClick={() => page > 1 && onPageChange(page - 1)}
            className={cn('h-fit cursor-pointer', page === 1 && 'pointer-events-none opacity-50')}
          />
        </PaginationItem>

        <PaginationItem>
          <span className='px-4 text-sm font-medium'>
            Page {page} of {totalPages}
          </span>
        </PaginationItem>

        <PaginationItem>
          <PaginationNext
            onClick={() => page < totalPages && onPageChange(page + 1)}
            className={cn('h-fit cursor-pointer', totalPages === 1 && 'pointer-events-none opacity-50')}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};

export default TablePagination;
